module.exports = __webpack_public_path__ + "img/749d8cae2293ddcb41ebe8291600bb9c.png";